import Immutable from 'immutable'

type TransactionProps = {
    amount: number
    cardName: string | null
    cardReadingMethod: string | null
    currency: string | null
    customerReceipt: string | null
    errorCode: string | null
    errorMessage: string | null
    id: string | undefined
    merchantReceipt: string | null
    offline: boolean | null
    paymentMethod: string | null
    responseCode: string | null
    responseMessage: string | null
    status: number | null
    terminalResult: any
    terminalResultJson: string | null
    terminalId: string | undefined
    terminalType: string | undefined
    transactionId: string | null
    transactionTime: string | null
    transactionType: string | null
    transactionUniqueId: string | null
}

export class Transaction extends Immutable.Record({
    amount: 0,
    cardName: null,
    cardReadingMethod: null,
    currency: null,
    customerReceipt: null,
    errorCode: null,
    errorMessage: null,
    id: undefined,
    merchantReceipt: null,
    offline: false,
    paymentMethod: null,
    responseCode: null,
    responseMessage: null,
    status: null,
    terminalResult: null,
    terminalResultJson: null,
    terminalId: undefined,
    terminalType: undefined,
    transactionId: null,
    transactionTime: null,
    transactionType: null,
    transactionUniqueId: null,
}) implements Readonly<TransactionProps> {
    // amount: number
    // cardName: string | null
    // cardReadingMethod: string | null
    // currency: string | null
    // customerReceipt: string | null
    // errorCode: string | null
    // errorMessage: string | null
    // id: string | undefined
    // merchantReceipt: string | null
    // offline: boolean | null
    // paymentMethod: string | null
    // responseCode: string | null
    // responseMessage: string | null
    // status: number | null
    // terminalResult: any
    // terminalResultJson: string | null
    // terminalId: string | undefined
    // terminalType: string | undefined
    // transactionId: string | null
    // transactionTime: string | null
    // transactionType: string | null
    // transactionUniqueId: string | null

    constructor(data: any = {}) {
        super(data)
    }

    static create = (amount, currency, terminalId, terminalType) => new Transaction({
        amount: amount,
        currency,
        status: TransactionStatus.PENDING,
        terminalId,
        terminalType,
        transactionType: amount < 0 ? TransactionType.REFUND : TransactionType.PURCHASE,
    })

    static isSuccessful = transaction => transaction.status === TransactionStatus.CLOSED && transaction.responseCode === ResponseCode.OK

    static isPending = transaction => transaction.status === TransactionStatus.PENDING
        || transaction.status === TransactionStatus.PENDING_UNKNOWN
        || transaction.status === TransactionStatus.CLOSED_NOT_PROCESSED
        || transaction.status === TransactionStatus.MISSING_NOT_PROCESSED

    static isForTerminal = (transaction, terminalId, terminalType) =>
        terminalId && terminalType && terminalId === transaction.terminalId && terminalType === transaction.terminalType

}

export const ResponseCode = {
    OK: '00',
}

export const TransactionStatus = {
    PENDING: 1,
    CLOSED: 2,
    MISSING: 3,
    PENDING_UNKNOWN: 11,
    CLOSED_NOT_PROCESSED: 12,
    MISSING_NOT_PROCESSED: 13,
}

export const TerminalType = {
    POPLATEK: 'poplatek',
    NEXI: 'nexi',
    UNKNOWN: '',
}

export const TransactionType = {
    PURCHASE: 'purchase',
    REFUND: 'refund',
}
